import React, { useState, useRef, useEffect } from "react";
const HighSpeedString = ({ getString, field, value, onClear }) => {
    const [qrCodeResult, setQrCodeResult] = useState(value || "");
    const [isEnterPressed, setIsEnterPressed] = useState(false);
    const ref = useRef();
    // Automatically focus the input field on component mount
    useEffect(() => {
        if (ref && ref.current) {
            ref.current.focus();
        }
    }, []);
    // Handle changes in the input field
    const handleChange = (event) => {
        // Append text only if Enter hasn't been pressed
        if (!isEnterPressed) {
            setQrCodeResult(event.target.value);
        }
    };
    // Handle keydown events for detecting Enter
    const handleKeyDown = (event) => {
        if (event.key === "Enter" || event.key === "Return") {
            setIsEnterPressed(true); // Stop further appending
            if (getString) {
                getString(qrCodeResult); // Send the value to the parent
            }
            //setQrCodeResult(""); // Clear the result
            setTimeout(() => setIsEnterPressed(false), 0); // Reset Enter state
            event.preventDefault(); // Prevent default Enter behavior
        }
    };
    return (
        <div className="col-sm-8 mt-4">
            <div className="row">
                <div className="col pr-0">
                    <div className="form-group">
                        <label className="small d-flex mb-0">
                            {field.FieldName}
                            {field.Compulsory && (
                                <p style={{ height: 5 }} className="text-danger">
                                    *
                                </p>
                            )}
                        </label>
                        <input
                            ref={ref}
                            className="form-control form-control-sm"
                            type="text"
                            value={qrCodeResult}
                            onChange={handleChange} // Update value on input change
                            onKeyDown={handleKeyDown} // Detect Enter key
                            placeholder={`${field.FieldName} here...`}
                        />
                    </div>
                </div>
                <div className="col mt-4 pl-0">
                    <button
                        onClick={() => {
                            if (onClear) {
                                onClear()
                            };
                            setQrCodeResult("")
                            if (ref && ref.current) {
                                ref.current.focus();
                            }
                        }}
                        className="btn btn-sm btn-danger"
                    >
                        Clear
                    </button>
                </div>
            </div>
        </div>
    );
};
export default HighSpeedString;